import CvSectionTemplate from './CvSectionTemplate';

export default function CvAdditionalInfo() {
  return (
    <CvSectionTemplate
      currentId="check_5"
      description="Zamieść tutaj wszelkie informacje, które mogą być przydatne, a nie pasują do innych sekcji."
    />
  );
}
